let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
item.addEventListener("mouseover", () => {
item.setAttribute("open", true);
item.querySelector("ul").addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
item.addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
});

});



/* price update on variant change */
$(document).ready(function(){
    setTimeout(() => {
            updateVariantPrice();
    }, 1000); 

    $(".product__info-wrapper variant-radios :radio").on('change', function(e){
        setTimeout(() => {
            updateVariantPrice();
        }, 250); 
    });
});
function updateVariantPrice(){

    if($(".hidden-pro-variants").length){
        var varVID= $(".product__info-wrapper variant-radios input[type='radio']:checked").attr("data-vid");
        var varID = $(".product__info-wrapper product-form input[name='id']").val();

        if (!varVID) {
            varVID = varID;
        }
        var varPrice = parseInt($(".hidden-pro-variants select option[value='"+ varVID +"']").attr("data-price"));
        var varCPrice = parseInt($(".hidden-pro-variants select option[value='"+ varVID +"']").attr("data-cprice"));
        var varDiscount = parseInt($(".hidden-pro-variants select option[value='"+ varVID +"']").attr("data-disc"));
         console.log('uppdatedddddd',varPrice,varCPrice,varDiscount,varVID);
         $('[name="id"]').val(varVID);
        if(varPrice != undefined){
            $(".product__info-wrapper .price-item.price-item--sale").html(Shopify.formatMoney(varPrice, 'Rs. {{amount}}'));
             console.log('updateddddundefined',varPrice,varCPrice,varDiscount); 
            $(".op_price").html(Shopify.formatMoney(varPrice, 'Rs. {{amount}}'));
        }
        if(varCPrice > varPrice){  
            $(".product__info-wrapper .price-item.price-item--regular").html(Shopify.formatMoney(varCPrice, 'Rs. {{amount}}'));
            $(".product__info-wrapper .price-item.price-item--regular").parents(".price").addClass("price--on-sale");
            console.log('varCPrice',varPrice,varCPrice,varDiscount);
            $(".op_price").html(Shopify.formatMoney(varPrice, 'Rs. {{amount}}'));
            $(".cp_price").html(Shopify.formatMoney(varCPrice, 'Rs. {{amount}}'));
        }else{ 
            $(".product__info-wrapper .price-item.price-item--regular").html(Shopify.formatMoney(varPrice, 'Rs. {{amount}}'));
            $(".product__info-wrapper .price-item.price-item--regular").parents(".price").removeClass("price--on-sale");
        }
        if(varDiscount > 0){
            $(".product__info-wrapper .discount-percent_main").html("("+varDiscount +"% OFF)");
            $(".product__info-wrapper .discount-percent_main").show();
        }else{
            $(".product__info-wrapper .discount-percent_main").hide();
        }
    }
}   
/* price update on variant change */

window.refreshCartDrawer = async function () {
  try {
    const sections = await fetch(
      `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`
    ).then(res => res.json());
    const parser = new DOMParser();
    const updateSection = (selector, html) => {
      const current = document.querySelector(selector);
      if (!current || !html) return;
      const updated = parser
        .parseFromString(html, "text/html")
        .querySelector(selector);
      if (updated) {
        current.replaceWith(updated);
      }
    };
    updateSection(
      "cart-drawer",
      sections["cart-drawer"]
    );
    updateSection(
      "cart-icon-bubble",
      sections["cart-icon-bubble"]
    );
    // Update count fallback
    const cart = await fetch("/cart.js")
      .then(res => res.json());
    const bubble = document.querySelector(
      ".cart-count-bubble"
    );
    if (bubble) {
      const count = bubble.querySelector(
        "[aria-hidden='true']"
      );
      const hidden = bubble.querySelector(
        ".visually-hidden"
      );
      if (count) {
        count.textContent = cart.item_count;
      }
      if (hidden) {
        hidden.textContent = `${cart.item_count} ${
          cart.item_count === 1 ? "item" : "items"
        }`;
      }

      bubble.classList.toggle(
        "is-empty",
        cart.item_count === 0
      );
    }
    // Re-open cart drawer
    const drawer = document.querySelector("cart-drawer");

    if (drawer) {
      if (typeof drawer.open === "function") {
        drawer.open();
      } else {
        drawer.classList.add("active");
        drawer.classList.remove("is-empty");
      }
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: cart
      })
    );

    return cart;

  } catch (error) {
    console.error("Cart refresh error:", error);
  }
};